module.exports = __webpack_public_path__ + "img/menuIcon10.f78c7a49.png";